import { render, staticRenderFns } from "./HeadingIcon.vue?vue&type=template&id=05d8fec0&scoped=true&"
import script from "./HeadingIcon.vue?vue&type=script&lang=js&"
export * from "./HeadingIcon.vue?vue&type=script&lang=js&"
import style0 from "./HeadingIcon.vue?vue&type=style&index=0&id=05d8fec0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d8fec0",
  null
  
)

export default component.exports